import { combineReducers } from "redux";
import banner from './cms.reducer';

const reducer = combineReducers({    
    banner
});

export default reducer;